import React, { Fragment, useEffect, useState } from "react";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import { Menu, Transition } from "@headlessui/react";
import { useNavigate } from "react-router-dom";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
import view from "../../../assests/tenant/images/view.svg";
import { toast } from "react-hot-toast";
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
import ModalComponent from "../../../components/Tenant/ModalComponent/ModalComponent";
import InputComponent from "../../../components/Tenant/InputComponent/InputComponent";
import { HiOutlinePlus } from "react-icons/hi";
import { hasPermission } from "../../../utils/hasPermission";
import { getVendorName } from "../../../utils/getVendorName";
import { useCreateParticipatingBrandMutation, useFetchAllParticipatingBrandsMutation, useUpdateParticipatingBrandMutation } from "../../../features/tenant/participatingBrands/participatingBrands";
import ImageModal from "../../../components/Tenant/ImageModal/ImageModal";
import { useUploadSingleFileMutation } from "../../../features/admin/imageUpload/imageUploadApi";

const ParticipatingBrand = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [showModal, setShowModal] = useState(false);
  const [brandName, setBrandName] = useState(null);

  const addBrandPermission = hasPermission("addBrand");
  const editBrandPermission = hasPermission("editBrand");
  const deleteBrandPermission = hasPermission("deleteBrand");

  const [selectedBrandId, setSelectedBrandId] = useState(-1);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationResetToggle, setPaginationResetToggle] = useState(false);
  const [showImage, setShowImage] = useState("")
  const [image, setImage] = useState("")
  const [productName, setProductName] = useState("");
  const [productImage, setProductImage] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [productImageUrl, setProductImageUrl] = useState("")


  useEffect(() => {
    fetchBrandListFunction()
  }, [])

  const handlePageChange = (pageNumber) => {
    const newOffset = (pageNumber - 1) * limit;
    setOffset(newOffset);
    setCurrentPage(pageNumber);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setLimit(newPerPage);
  };

  const [fetchBrandList, { data: brandsData, error: brandsError }] =
    useFetchAllParticipatingBrandsMutation();

  const [
    uploadImage,
    {
      data: uploadImageData,
      isLoading: uploadImageIsLoading,
      error: uploadImageError,
    },
  ] = useUploadSingleFileMutation();

  const uploadImageFunc = (file) => {
    const formData = new FormData();
    formData.append("image", file);
    uploadImage({
      body: formData
    });
  };

  useEffect(() => {
    if (uploadImageData) {
      setProductImageUrl(uploadImageData.body.fileLink)
    }
    if (uploadImageError) {
      console.log(uploadImageError)
    }
  }, [uploadImageData, uploadImageError])

  const fetchBrandListFunction = (e) => {
    fetchBrandList({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id
    });
  };

  const [addBrand, { data: addbrandData, error: addBrandError }] =
    useCreateParticipatingBrandMutation();

  const [updateBrand, { data: updateBrandData, error: updateBrandError }] =
    useUpdateParticipatingBrandMutation();

  useEffect(() => {
    if (addbrandData) {
      toast.success("Brand Added", {
        id: "brandAddSucess",
      });

      setBrandName(null);
      setProductImage(null)
      setProductImageUrl("")
      setProductName("")
      setStartDate(null)
      setEndDate(null)
      setShowModal(!showModal);
      fetchBrandList({
        token: sessionStorage.getItem("access_token"),
        tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      });
    }
    if (addBrandError) {
      toast.error("Some Error Occured", {
        id: "brandAddError",
      });
    }
  }, [addbrandData, addBrandError]); 
  
  useEffect(() => {
    if (updateBrandData) {
      toast.success("Brand Updated", {
        id: "brandAddSucess",
      });

      setBrandName(null);
      setProductImage(null)
      setProductImageUrl("")
      setProductName("")
      setStartDate(null)
      setEndDate(null)
      setShowModal(!showModal);
      fetchBrandList({
        token: sessionStorage.getItem("access_token"),
        tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      });
    }
    if (updateBrandError) {
      toast.error("Some Error Occured", {
        id: "brandAddError",
      });
    }
  }, [updateBrandData, updateBrandError]);

  const handleAddBrand = (e) => {
    e.preventDefault();
    if (!brandName || !productName || !startDate || !endDate) {
      toast.error("Please enter all fields", {
        id: "brandNameError",
      });
      return;
    }


    let body = {
      brand: brandName, product_name: productName, start_date: startDate, end_date: endDate,
      status: "1"
    }

    if (productImageUrl) {
      body["product_image"] = productImageUrl
    }

    addBrand({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body
    });
    fetchBrandListFunction("");
  };

  const handleUpdateBrand = (e) => {
    e.preventDefault();
    if (!brandName) {
      toast.error("Please enter Brand name", {
        id: "brandNameError",
      });
      return;
    }

    let updateBody = {
      id: selectedBrandId
    }

    if (brandName) {
      updateBody["brand"] = brandName
    }

    if (productName) {
      updateBody["product_name"] = productName
    }

    if (startDate) {
      updateBody["start_date"] = startDate
    }

    if (endDate) {
      updateBody["end_date"] = endDate
    }

    if (productImageUrl) {
      updateBody["product_image"] = productImageUrl
    }

    updateBrand({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: updateBody,
    });
  };

  const handleShowModal = (type, data) => {
    if (type === "add") {
      // const flag = hasPermission("addBrand");
      // console.log("object has permission", flag);
      // if (!flag) {
      //   alert("You are not allowed to do this");
      //   return;
      // }
      setShowModal(true);
      setSelectedBrandId(-1);
      setBrandName(null);
      setProductImage(null)
      setProductImageUrl("")
      setProductName("")
      setStartDate(null)
      setEndDate(null)
      // console.log("add Brand permission " , hasPermission("addBrand"));
    }

    if (type === "edit") {
      console.log("data>",{
        data
      })
      setSelectedBrandId(Number(data.id));
      setBrandName(data.brand);
      setShowModal(true);
      setProductName(data.product_name)
      setStartDate(data.start_date.split("T")[0])
      setEndDate(data.end_date.split("T")[0])
    }
  };

  const handleProductImage = (row) => {
    setShowImage(!showImage)
    setImage(row.product_image ?? "")
  };

  const handleStatusUpdate = (row) => {
    updateBrand({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: {
        id: row.id,
        status: row.status == "1" ? "2" : "1"
      }
    });
  }


  const columns = [
    {
      name: "SNo",
      cell: (row, idx) => (offset) + Number(idx + 1),
      sortable: true,
    },
    {
      name: "Brand",
      cell: (row) => row.brand,
      sortable: true,
    },
    {
      name: "Product Name",
      cell: (row) => row.product_name,
      sortable: true,
    },
    {
      name: "Start Date",
      cell: (row) => new Date(row.start_date).toLocaleDateString(),
      sortable: true,
    },
    {
      name: "End Date",
      cell: (row) => new Date(row.end_date).toLocaleDateString(),
      sortable: true,
    },
    {
      name: "Image",
      width: "150px",
      cell: (row) => {
        if (
          !row.product_image
        ) return (<></>)
        return (
          <>
            <button
              type="button"
              className="bg-black p-1 rounded-sm"
            >
              <img
                src={view}
                alt=""
                onClick={() =>
                  handleProductImage(row)
                }
              />
            </button>


          </>
        )
      }
    },
    {
      name: "Status",
      cell: (row) =>
        row.status != "1" ? (
          <button
            className="btn btn-outline-secondary btn-sm"
            onClick={() => handleStatusUpdate(row)}
          >
            Inactive
          </button>
        ) : (
          <button
            className="btn btn-outline-primary btn-sm"
            onClick={() => handleStatusUpdate(row)}
          >
            Active
          </button>
        ),
      ignoreRowClick: true,
      button: true,
    },
    {
      name: "",
      cell: (row) =>
        editBrandPermission && (
          <div>
            <button
              onClick={() => handleShowModal("edit", row)}
              className="flex justify-center items-center rounded bg-primary px-3 pb-1.5 pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-primary-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-primary-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)]"
            >
              <AiOutlineEdit className="mr-1" />
              Edit
            </button>
          </div>
        ),
      minWidth: "100px",
    },
  ];

  const primaryColor = JSON.parse(sessionStorage.getItem("vendorTheme")).theme
    .color_shades;
  return (
    <>
      <div className="flex w-full bg-gray-200 h-full justify-center">
        <div className="w-full ">
          <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
            Participating Brand List
            <LinksComponent />
          </div>

          <div className="p-3">
            <div className=" p-3 w-full bg-white shadow rounded-lg">
              <DataTableComponent
                keyField={(row) => row.SNo}
                columns={columns}
                data={brandsData?.body}
                pagination={false}
              >
              </DataTableComponent>
              {addBrandPermission && (
                <div
                  className="fixed bottom-0 right-16 w-16 h-16 mr-10 mb-2 cursor-pointer"
                  id="box_btn"
                >
                  <div className="text-right">
                    <Menu className="relative inline-block text-left">
                      <div>
                        <Menu.Button
                          onClick={() => handleShowModal("add")}
                          className="inline-flex justify-cente w-12 h-12 rounded-full text-sm font-medium text-white hover:bg-opacity-80 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 "
                          style={{ backgroundColor: `${primaryColor["700"]}` }}
                        >
                          <HiOutlinePlus className="w-full h-full p-3" />
                        </Menu.Button>
                      </div>
                      {/* <Transition
                      as={Fragment}
                      enter="transition ease-out duration-100"
                      enterFrom="transform opacity-0 scale-95"
                      enterTo="transform opacity-100 scale-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform opacity-100 scale-100"
                      leaveTo="transform opacity-0 scale-95"
                    >
                      <Menu.Items className="absolute -top-12 right-0 mt-2 w-56 divide-y divide-gray-100 rounded-md bg-blue-200 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                        <div
                          onClick={() => navigate(`add`)}
                          className="p-2 font-semibold hover:text-gray-600 "
                        >
                          Add New Batch
                        </div>
                      </Menu.Items>
                    </Transition> */}
                    </Menu>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {showModal && (
          <ModalComponent
            size={"md"}
            data={"add_product"}
            show={showModal}
            setShow={setShowModal}
          >
            <div className="w-full p-3 space-y-6">
              {/* Brand */}
              <InputComponent
                name={"Brand Name"}
                type={"text"}
                value={brandName}
                placeholder={"Enter brand name"}
                setValue={setBrandName}
                required={true}
              />

              {/* Product Name */}
              <InputComponent
                name={"Product Name"}
                type={"text"}
                value={productName}
                placeholder={"Enter product name"}
                setValue={setProductName}
                required={true}
              />

              {/* Product Image */}
              <div className="flex flex-col">
                <label className="mb-1 text-sm font-medium">Product Image</label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={async (e) => {
                    const file = e.target.files?.[0];
                    if (file) {
                      setProductImage(file);
                      uploadImageFunc(file); // make sure you wait
                    }
                  }}
                  className="block w-full text-sm border rounded-lg cursor-pointer focus:outline-none"
                />
              </div>

              {/* Start Date */}
              <InputComponent
                name={"Start Date"}
                type={"date"}
                value={startDate}
                placeholder={"Select start date"}
                setValue={setStartDate}
                required={true}
              />

              {/* End Date */}
              <InputComponent
                name={"End Date"}
                type={"date"}
                value={endDate}
                placeholder={"Select end date"}
                setValue={setEndDate}
                required={true}
              />

              {/* Action Buttons */}
              <div className="flex justify-center">
                {selectedBrandId === -1 ? (
                  <button
                    type="submit"
                    className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                    onClick={(e) => handleAddBrand(e)}
                  >
                    Add
                  </button>
                ) : (
                  <button
                    type="submit"
                    className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                    onClick={(e) => handleUpdateBrand(e)}
                  >
                    Update
                  </button>
                )}
              </div>
            </div>
          </ModalComponent>
        )}


        {showImage && (
          <ImageModal
            show={showImage}
            setShow={setShowImage}
            size="md"
            data={image}
          >
            <div className="w-[400px] h-[400px] overflow-hidden rounded-lg bg-gray-200">
              <img
                src={image}
                alt="product-image"
                className="w-full h-full object-contain"
              />
            </div>
          </ImageModal>
        )}

      </div>
    </>
  );
};

export default ParticipatingBrand;
